import { usePaymentNavigation } from "@/features/payment/hooks/use-payment-navigation.ts";

export const PaymentNavigationHandler = () => {
  usePaymentNavigation();
  return null;
};
